import { useState, useEffect } from 'react';
import apiClient from '../api/apiClient';

export function useMemberships(startDate, endDate) {
  const [data, setData] = useState({ totals: {}, salesTable: [], recurringServices: { due: [], booked: [] } });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!startDate || !endDate) return;
    setLoading(true);
    setError(null);
    apiClient.get('/memberships', { params: { startDate, endDate } })
      .then(r => setData(r.data))
      .catch(e => setError(e.response?.data?.error || 'Failed to load membership data'))
      .finally(() => setLoading(false));
  }, [startDate, endDate]);

  return { ...data, loading, error };
}
